import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { FailedNotify, SuccessNotify } from "../constants/tostify";
import { 
  useUpdateUserProfileMutation, 
  useCheckMarketerAvailabilityQuery 
} from "../features/user/userApiSlice";

export const useProfileSectionState = ({ infooo, setInfooo, id }) => {
  const { name } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const location = useLocation();

  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [editbox, setEditbox] = useState("");
  const [shows, setShows] = useState(false);
  const [marketerverify, setMarketerverify] = useState(false);
  
  const [createShop, setCreateShop] = useState({
    atext: "",
    aprivacy: "",
    btext: "",
    bprivacy: "",
    bdegree: "",
    ctext: "",
    cprivacy: "",
    email: "",
    createdAt: "",
  });

  const boxOpen = () => {
    setPrivacyOpen(!privacyOpen);
  };

  const handleClose = () => setShows(0);
  const handledelete = () => {};

  const inputChange = (event) => {
    setCreateShop((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  const [updateProfile] = useUpdateUserProfileMutation();

  const handleUpdate = async (dataPayload) => {
    try {
      const response = await updateProfile({
        id: name?._id,
        data: dataPayload,
      }).unwrap();

      if (response?.success) {
        setEditbox(false);
        SuccessNotify("Successfully!");
        if (response?.data?.User) {
          setInfooo(response.data.User);
        }
      }
    } catch (e) {
      console.log("error", e);
      setEditbox(false);
      FailedNotify("Failed! Try Again");
    }
  };

  const userDatahandler = (value) => {
    const payload = { address: { text: value !== undefined ? value : createShop.atext } };
    if (createShop.aprivacy) payload.address.privacy = createShop.aprivacy;
    handleUpdate(payload);
  };

  const userDatahandler1 = (value) => {
    const eduItem = { text: value !== undefined ? value : createShop.btext };
    if (createShop.bprivacy) eduItem.privacy = createShop.bprivacy;
    if (createShop.bdegree) eduItem.degree = createShop.bdegree;
    handleUpdate({ education: [eduItem] });
  };

  const userDatahandler2 = (value) => {
    const payload = { contactNumber: { text: value !== undefined ? value : createShop.ctext } };
    if (createShop.cprivacy) payload.contactNumber.privacy = createShop.cprivacy;
    handleUpdate(payload);
  };

  const userDatahandler3 = (value) => {
    handleUpdate({ email: value !== undefined ? value : createShop.email });
  };

  const userDatahandler4 = (value) => {
    handleUpdate({ createdAt: value !== undefined ? value : createShop.createdAt });
  };

  const { data: availabilityData, isSuccess: isAvailabilitySuccess } = useCheckMarketerAvailabilityQuery(
    name?._id,
    { skip: !name?._id }
  );

  useEffect(() => {
    if (isAvailabilitySuccess && availabilityData) {
      setMarketerverify(availabilityData.available);
    }
  }, [isAvailabilitySuccess, availabilityData]);

  const handlePrivacyToggle = async (val) => {
    // Do NOT optimistically update infooo here — that causes a blink because
    // handleUpdate also calls setInfooo on success, producing two rapid state changes.
    // The server response via handleUpdate will update infooo with the confirmed value.
    await handleUpdate({ hideConnections: val });
  };

  return {
    privacyOpen,
    editbox,
    setEditbox,
    shows,
    setShows,
    marketerverify,
    createShop,
    boxOpen,
    handleClose,
    handledelete,
    inputChange,
    userDatahandler,
    userDatahandler1,
    userDatahandler2,
    userDatahandler3,
    userDatahandler4,
    handlePrivacyToggle,
    location,
    navigate,
  };
};
